import { ConfirmDeleteModal } from '~/utils/modals';
import AdminWfDesignerService from '../../../scripts/services/model/admin-wf-designer.service';

export default class AdminWfController {
	/** @type {any} */
	#temporaryFile;

	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {import('angular').ILocationService} $location
	 * @param {any} $rootScope
	 * @param {import('angular').route.IRouteParamsService} $routeParams
	 * @param {any} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {any} NodeService
	 * @param {any} Notification
	 * @param {any} User
	 */
	constructor(
		$injector,
		$location,
		$rootScope,
		$routeParams,
		$scope,
		$timeout,
		$translate,
		NodeService,
		Notification,
		User,
	) {
		this.$injector = $injector;
		this.$location = $location;
		this.$rootScope = $rootScope;
		this.$routeParams = $routeParams;
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.NodeService = NodeService;
		this.Notification = Notification;
		this.User = User;

		this.#temporaryFile = undefined;
		this.active = 0;

		/** @type {any} */
		this.roles = undefined;

		/** @type {any} */
		this.tabs = [
			{
				id:     'home',
				schema: {
					kid:     null,
					getName: () => this.$translate.instant('common.home'),
				},
			},
		];

		this.$scope.$on('jsplumb.instance.created', (/** @type {any} */ event, /** @type {any} */ instance) => {
			if (this.active === 999 || this.active === null || this.active === 0) {
				this.active = this.tabs.length - 1;
			}
			this.tabs[this.active].init(instance);
		});

		this.$scope.$on('$locationChangeSuccess', async () => {
			const search = this.$location.search();
			if ('kid' in search) {
				await this.open(
					search.kid,
					'edit' in search,
					'create' in search,
					'duplicate' in search,
				);
			}
		});

		this.$scope.$on('Form.nrReplace', (/** @type {any} */ event, /** @type {any} */ nr) => {
			const search = this.$location.search();
			for (const [oldKid, newKid] of Object.entries(nr)) {
				for (const tab of this.tabs) {
					if (`K_NODE;${tab.id}` === oldKid) {
						tab.id = newKid.split(';')[1];
						if ('kid' in search && search.kid === oldKid) {
							this.$location.search({
								create: null,
								edit:   tab.edit,
								kid:    `K_NODE;${tab.id}`,
							}).replace();
						}
					}
				}
			}
		});

		if (this.$routeParams.kid) {
			(async () => this.open(
				this.$routeParams.kid,
				this.$routeParams.edit || false,
				this.$routeParams.create || false,
			))();
		}
		else {
			this.active = 0;
		}
	}

	/**
	 * @param {number} index
	 */
	closeWF(index) {
		if (index > 0) {
			this.tabs[index]?.close().then(() => {
				this.active = this.active >= index && index - 1 in this.tabs ? index - 1 : 0;
				this.tabs.splice(index, 1);
				this.$scope.$apply();
				return this.active;
			}).catch(() => {});
		}
	}

	/**
	 * @param {import('~/scripts/services/model/workflow').default} wf
	 * @returns {Promise<any>}
	 */
	async confirmDeleteWorkflow(wf) {
		const modal = new ConfirmDeleteModal(this.$injector);
		const answer = await modal.open(wf.name || '');

		if (answer) {
			return this.NodeService.delete(wf.kid);
		}

		return false;
	}

	/**
	 * @param {File[]} files
	 */
	import(files) {
		if (this.active) {
			this.tabs[this.active].import(files[0]);
		}
		else {
			this.#temporaryFile = files[0];
			this.newWF();
		}
	}

	/**
	 * @param {import('@knitiv/api-client-javascript').KNode} workflowKid
	 * @param {boolean} edit
	 * @param {boolean | undefined} duplicate
	 * @returns {Promise<AdminWfDesignerService | undefined>}
	 */
	async load(workflowKid, edit, duplicate) {
		const newTab = new AdminWfDesignerService(this.$injector);
		const tab = await newTab.load(workflowKid, edit, duplicate);

		if (tab) {
			this.tabs.push(tab);
			this.$timeout(() => {
				tab.schema.roles = this.roles;
			});
			return tab;
		}
		return undefined;
	}

	newWF() {
		this.$location.search({ create: true, edit: true, kid: `K_NODE;${this.User.getRef()}` });
	}

	/**
	 * @param {import('@knitiv/api-client-javascript').KNode | 'home'} workflowKid
	 * @param {boolean} edit
	 * @param {boolean} create
	 * @param {boolean | undefined} [duplicate]
	 */
	async open(workflowKid, edit, create, duplicate) {
		// search in tabs if one is opened
		if (workflowKid === 'home') {
			this.active = 0;
		}
		else {
			let isOpen = false;
			for (const [k, tab] of this.tabs.entries()) {
				if (`K_NODE;${tab.id}` === workflowKid) {
					this.active = k;
					isOpen = true;
				}
			}

			if (!isOpen) {
				if (create) {
					const newTab = new AdminWfDesignerService(this.$injector);
					await newTab.createSchema(workflowKid);
					this.tabs.push(newTab);
					this.$timeout(() => {
						this.active = this.tabs.length - 1;
						if (this.#temporaryFile) {
							this.tabs[this.active].import(this.#temporaryFile);
							this.$timeout(() => {
								this.#temporaryFile = null;
							});
						}
					});
				}
				else {
					// this.$timeout(async () => {
					await this.load(workflowKid, edit, duplicate);
					this.active = this.tabs.length - 1;
					// });
				}
			}
			this.$timeout(() => {
				this.$rootScope.title = this.tabs[this.active].schema.getName();
			});
		}
	}

	/**
	 * @param {import('@knitiv/api-client-javascript').KNode | 'home'} workflowKid
	 * @param {boolean} edit
	 * @param {boolean} create
	 * @param {boolean} duplicate
	 */
	updatePath(workflowKid, edit, create, duplicate) {
		if (!workflowKid) {
			return;
		}

		if (workflowKid === 'home') {
			this.$rootScope.title = this.$translate.instant('menu.admin-workflow');
			this.$location.search({
				create: null,
				edit: null,
				kid: null,
				duplicate: null,
			});
		}
		else {
			this.$location.search({
				create: create || null,
				edit: edit || null,
				kid: workflowKid,
				duplicate: duplicate || null,
			});
		}
	}
}
